import { InvestFundService } from './invest-fund.service';
import { isNull } from 'util';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatButtonModule, MatFormFieldModule, MatInputModule } from '@angular/material';


export class FundsIncome {
  public yearLabels = ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"];
  public monthLables: Array<string> = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
  public lastMonths: Array<string> = ["Fundo"];
  public allFundsLastMonths: Array<Array<string>> = [];
  public currentMonth;

  public fundsNames: Array<string>;
  public fundsLabels: Array<string>;
  public fundsAmounts: Array<number>;
  public funds: Array<InvestFund>;
  public fundsCategories: Array<string>;

  public selectedFund: Array<string> = [];
  public selectedMonth: number = new Date().getMonth() + 1;
  public selectedYear: string = new Date().getFullYear().toString();
  public fundInvestedValue;
  public fundCalcReturn;
  public fundTotalCalcReturn = 0;
  public newFundLabel;
  public newFundName;
  public newFundCnpj;
  public fundsCnpj;

  public allAvailableFunds = new Array<InvestFund>();
  public allAvailableFundsCtrl = new FormControl();
  public filteredFunds: Observable<InvestFund[]>;

  public href: string = "";

  constructor(private svc: InvestFundService, private router: Router) {
    this.href = this.router.url;
    if(this.href == '/invest-fund-old'){
      this.fundsNames = ["capitania-prev-advisory-xp-seguros-fic-fi-rf-cp","az-quest-luce-fic-fi-rf-cp-lp", "arx-denali-fic-fi-rf-cp", "itau-optimus-rf-lp-fic-fi", "itau-legend-rf-lp-fic-fi", "itau-global-dinamico-rf-lp-fic-fi", "vinland-macro-advisory-xp-seguros-prev-fic-fi-mult", "legacy-capital-previdenciario-advisory-xp-seguros-fic-fim", "icatu-seg-fic-fi-corporate-rf", "az-quest-icatu-multi-prev-fic-fim", "icatu-vanguarda-fic-fi-inflacao-longa-rf-lp",  "equitas-selection-fic-fia",  "pacifico-macro-fic-fim",  "exploritas-alpha-america-latina-fic-fim",  "selection-long-biased-fic-fim",  "giant-sigma-advisory-fic-fim",  "az-quest-top-long-biased-fic-fia",  "ibiuna-hedge-sth-fic-fim",  "jgp-strategy-advisory-fic-fim"];
      this.fundsLabels = ["CapPrev", "AzQ Luce", "ARX Denali", "Itau Optimus", "ItauLegend", "ItauGlobalRF", "VinlandPrev", "LegacyPrev", "GIcatuPrev", "GAzPrev", "IcatuInflacao",  "Equitas",  "Pacifico",  "Exploritas",  "SelecLongBiased",  "GiantSigma",  "AzQuestTop",  "IbiunaHedge",  "JGP Strategy"];
      this.fundsAmounts = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100];
      this.fundsCnpj = ["32319658000157", "23556185000110", "30921203000181", "40498539000137", "29197055000115", "32972925000190", "31846723000130", "34287126000100", "33499634000190", "18534967000119", "07400556000114", "12004203000135", "22354046000141", "19628666000117", "24582422000180", "34186116000189", "13974750000106", "15799713000134", "30190210000150"];
      this.fundsCategories = ["RF", "RF", "RF", "RF", "RF", "RF", "Multimercado", "Multimercado", "RF", "Multimercado", "Inflacao", "Acoes", "Multimercado", "Multimercado", "Acoes", "Multimercado", "Acoes", "Multimercado", "Multimercado"];
    } else {
      this.fundsNames = ["trend-pos-fixado-xp-seguros-prev-fic-rf-rl","itau-rf-diferenciado-cp-fi-financeiro-da-cic-rl-1", "itau-kinea-rf-absoluto-lp-fif-da-classe-fic-rl","vinland-macro-advisory-xp-seguros-prev-fic-multimercado-rl", "legacy-capital-prev-advisory-xp-seguros-fic-multimercado-rl", "icatu-seg-fic-fif-corporate-rf-rl", "az-quest-icatu-multi-prev-fic-fi-financeiro-multimercado-rl"];
      this.fundsLabels = ["TrendPrev", "Itau DifCp", "ItauKineaRF", "VinlandPrev", "LegacyPrev", "GIcatuPrev", "GAzPrev"];
      this.fundsAmounts = [126000, 85000, 29000, 30000, 30000, 40000, 14000];
      this.fundsCnpj = ["33784231000192", "20335522000151", "28851710000144", "31846723000130", "34287126000100", "33499634000190", "18534967000119"];
      this.fundsCategories = ["RF", "RF", "RF", "Multimercado", "Multimercado", "RF", "Multimercado"];
    }
    
    this.funds = [];
    for (let index = 0; index < this.fundsNames.length; index++) {
      this.funds.push(new InvestFund(this.fundsNames[index], this.fundsLabels[index], this.fundsAmounts[index], this.fundsCnpj[index], this.fundsCategories[index]));
    }

    var fundListCache = localStorage.getItem('allFundsList');

    if (!fundListCache) {
      this.svc.getAllFundsList().subscribe(data => {
        this.prepareFundSearchComponent(data);
        localStorage.setItem('allFundsList', JSON.stringify(data));
      });
    }
    else {
      this.prepareFundSearchComponent(JSON.parse(fundListCache));
    }
  }



  //Auxiliar methods
  public updateAllFundsMonthTable(updatedFund: Array<string>, fundName: string, referenceMonth: number, lastQuoteDate: Date) {
    var qtdMonthsOnHeader = (referenceMonth < 4) ? referenceMonth : 4;
    var lowestMonth = (referenceMonth < 4) ? 0 : referenceMonth - 4;
    //Create header for last 4 months
    for (let i = 0; i < qtdMonthsOnHeader; i++) {
      this.lastMonths[i + 1] = this.monthLables[lowestMonth + i];
    }

    //Create arrays with just last 4 months
    var auxArray = [fundName];
    this.allFundsLastMonths.push(auxArray.concat(updatedFund.slice(lowestMonth, referenceMonth)));

    //Sort by last month return desc
    this.allFundsLastMonths.sort((a,b) => (Number(a[a.length-1]) < Number(b[b.length-1])) ? 1: (Number(b[b.length-1]) < Number(a[a.length-1])) ? -1 : 0);
  }

  public calculateReturns(fund: Array<string>, month: number, investedQtd: number): number {
    var fundTax = Number(fund[month - 1]);
    return investedQtd * fundTax / 100;
  }

  public calculateMonthTotalReturns(): number {
    var totalReturn = 0;
    this.funds.forEach(fund => {
      var fundTax = Number(fund.returns[this.selectedMonth - 1]);
      var investedQtd = fund.amount;

      var fundReturn = investedQtd * fundTax / 100;
      totalReturn = totalReturn + fundReturn;
    });

    this.fundTotalCalcReturn = totalReturn;
    return totalReturn;
  }

  private filterFunds(value: string): InvestFund[] {
    if (value.length > 3) {
      const filterValue = value.toLowerCase();
      return this.allAvailableFunds.filter(f => f.label.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  private getFundText(fund: InvestFund): string {
    return fund ? fund.label : "";
  }

  private prepareFundSearchComponent(fundsJsonData: any) {
    var allFundsFromJson: FundListSchema[] = fundsJsonData;

    allFundsFromJson.forEach(element => {
      if (element.s && element.n && element.c && element.e != "c" && element.e != "p") {
        this.allAvailableFunds.push(new InvestFund(element.s, element.n, 0, element.c));
      }
    });

    this.filteredFunds = this.allAvailableFundsCtrl.valueChanges
      .pipe(
        startWith(''),
        map(f => f ? this.filterFunds(f) : this.allAvailableFunds.slice(0, 10))
      );
  }


  //Screen Interctions Events
  onKeyFundReturnCalc(event: any) {
    var num = (event.target.value as string).replace('.', '');
    this.fundInvestedValue = Number(num);
    if (this.selectedFund.length == 0) {
      this.selectedFund = this.funds[0].returns;
    }
    this.fundCalcReturn = this.calculateReturns(this.selectedFund, this.selectedMonth, this.fundInvestedValue).toString();
  }

  onSelectedMonthChange(event: any) {
    var index = this.monthLables.indexOf(event.target.value);
    this.selectedMonth = index + 1;

    this.fundCalcReturn = this.calculateReturns(this.selectedFund, this.selectedMonth, this.fundInvestedValue).toString();
  }

  onSelectedFundChange(event: any) {
    if (isNull(this.fundInvestedValue)) {
      this.fundInvestedValue = 0;
    }
    var changedFund = this.funds.find(x => x.label === event.target.value);
    this.selectedFund = changedFund.returns;
    this.fundCalcReturn = this.calculateReturns(this.selectedFund, this.selectedMonth, this.fundInvestedValue).toString();
  }

}

export class InvestFund {
  public name: string;
  public label: string;
  public cnpj: string;
  public returns: Array<string>;
  public amount: number;
  public category: string;
  public lastUpdate: Date;
  public yearTotalReturn: string;

  constructor(name: string, label: string, amount: number, cnpj?: string, category?: string) {
    this.name = name;
    this.label = label;
    this.cnpj = cnpj;
    this.returns = [];
    this.amount = amount;
    this.category = category;
    this.lastUpdate = null;
    this.yearTotalReturn = "";
  }
}

export interface FundListSchema {
  c: string; //cnpj
  n: string; //label
  s: string; //url_name
  e: string; //state (c=canceled | p=pre_operational)
}